var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.data)?_c('div',{staticClass:"content"},[_vm._m(0),_vm._l((_vm.list),function(item){return _c('env-info-item',{key:item.idx,attrs:{"data":item}})})],2):_vm._e()
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex-line",staticStyle:{"position":"relative"}},[_c('div',{staticClass:"title1"},[_vm._v("土壤数据分析")])])
}]

export { render, staticRenderFns }